// @ts-nocheck
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import VuiNumberFormat from '../VuiNumberFormat';

interface IVuiWidget {
  tooltip?: string;
  title: string;
  value: number;
}

const VuiWidget: React.FC<IVuiWidget> = ({ tooltip, value, title }) => {
  return (
    <div className={'card-paper'}>
      <div className={'card-header'}>
        <h6 className={'card-header-title'}>{title}</h6>
        <OverlayTrigger
          key={`tooltip-overlay-gmv`}
          placement={'top'}
          overlay={
            <Tooltip id={`tooltip-gmv`}>
              <i>{tooltip}</i>
            </Tooltip>
          }
        >
          <FontAwesomeIcon className={'icon'} icon={faExclamationCircle} />
        </OverlayTrigger>
      </div>
      <div className={'card-content'}>
        <h5>
          <VuiNumberFormat value={value} data={value} prefix={'IDR '} />
        </h5>
      </div>
    </div>
  );
};

export default VuiWidget;
